import * as types from "../actions/actionTypes";

const initialState = {
  banners: [],
  banner: null,
};

const banner = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_BANNER_RESPONSE:
      return { ...state, banners: action.payload };
    case types.GET_BANNER_RESPONSE:
      return { ...state, banner: action.payload };
    case types.GET_INACTIVE_BANNER:
      return { ...state, banner: [] };
    case types.CREATE_BANNER:
      return { ...state, banner: null };
    case types.UPDATE_BANNER:
      return { ...state, banner: null };
    case types.DELETE_BANNER:
      return { ...state, banner: null };
    default:
      return state;
  }
};

export default banner;
